export function getVoteAnimationVars(marketId, optionId) {
  const seed = hashString(`${String(marketId || "")}:${String(optionId || "")}`);
  const phase = normalize(seed);
  const phase2 = normalize(seed * 1103515245 + 12345);

  const gradientDuration = lerp(6.6, 9.4, phase);
  const sweepDuration = lerp(2.3, 3.6, phase2);
  const sweepDelay = -sweepDuration * phase;

  return {
    "--vote-grad-dur": `${gradientDuration.toFixed(2)}s`,
    "--vote-sweep-dur": `${sweepDuration.toFixed(2)}s`,
    "--vote-sweep-delay": `${sweepDelay.toFixed(2)}s`
  };
}

function hashString(value) {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

function normalize(value) {
  return (value >>> 0) / 4294967295;
}

function lerp(min, max, t) {
  return min + (max - min) * t;
}
